/* relvie-gallery.js — makes the main product gallery on cloned PDPs click-through.
   The competitor galleries we clone (Swiper, Glide, GemPages, Dawn variants, custom theme carousels)
   lose their JavaScript when cloned, so they freeze on the first image and their arrows/thumbnails do
   nothing. This finds the main gallery track and turns it into a native scroll-snap carousel:
   swipe works on mobile, thumbnails and arrows scroll to their slide, and arrows are added where the
   page has none. Galleries that already show every image (stacked/two-column grids) are left alone.
   Loaded from layout/theme.liquid on product pages only. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var MIN_SLIDE_W = 180;

  function hasImg(el) { return /^(IMG|PICTURE|VIDEO)$/.test(el.tagName) || !!el.querySelector('img, picture, video'); }
  function imgOf(el) { return el.tagName === 'IMG' ? el : el.querySelector('img'); }
  function rect(el) { return el.getBoundingClientRect(); }
  function isDup(el) { return /duplicate|cloned|clone/.test(el.className || ''); }

  function slidesOf(track) {
    var out = [];
    for (var i = 0; i < track.children.length; i++) {
      var c = track.children[i];
      if (c.tagName === 'SCRIPT' || c.tagName === 'STYLE' || c.tagName === 'TEMPLATE') continue;
      if (isDup(c) || !hasImg(c)) continue;
      out.push(c);
    }
    return out;
  }

  function shown(el) {
    var cs = getComputedStyle(el), r = rect(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05 && r.width > 0 && r.height > 0;
  }

  /* The main gallery track: a container near the top of the page whose children are image slides,
     at least one of which renders large. Thumbnail strips (small images) are excluded. */
  function findTrack(root) {
    var best = null, bestScore = 0;
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.blocky-featured-product, #relvie-offer-slot, .moonbundle-box, .quickPurchased, .quick-add-cart, .rc-body, [class*=reviews], [class*=Reviews], [class*=jdgm], [class*=testimonial], [id*=review], footer, header')) continue;
      if (el.children.length < 2) continue;
      var slides = slidesOf(el);
      if (slides.length < 2 || slides.length < el.children.length * 0.6) continue;
      /* a real slide holds one image (maybe plus a badge); a child holding several is a wrapper
         around the whole slide list or thumbnail strip, so this element is not the track */
      var wrapper = false;
      for (var w = 0; w < slides.length; w++) { if (slides[w].tagName !== 'IMG' && slides[w].querySelectorAll('img').length > 2) { wrapper = true; break; } }
      if (wrapper) continue;
      var r = rect(el);
      var top = r.top + window.scrollY;
      if (top > 1400 || r.width < MIN_SLIDE_W) continue;
      var maxW = 0;
      for (var j = 0; j < slides.length; j++) {
        var img = imgOf(slides[j]);
        if (img) maxW = Math.max(maxW, rect(img).width, rect(slides[j]).width);
      }
      if (maxW < MIN_SLIDE_W) continue;
      var score = slides.length * 10 + maxW / 10 - top / 50;
      if (score > bestScore) { best = el; bestScore = score; }
    }
    return best;
  }

  /* Needs help when only one slide is actually visible to the shopper: others hidden, translated
     out of a clipping container, or overlapping in the same cell. */
  function needsCarousel(track, slides) {
    var tr = rect(track), visible = 0, lefts = {};
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (!shown(s)) continue;
      var r = rect(s);
      var inside = r.right > tr.left + 10 && r.left < tr.right - 10 && r.right <= window.innerWidth + 10 && r.left >= -10;
      if (!inside) continue;
      var key = Math.round(r.left / 20) + ':' + Math.round(r.top / 20);
      if (lefts[key]) continue;
      lefts[key] = 1;
      visible++;
    }
    return visible < slides.length;
  }

  function stackedAllVisible(track, slides) {
    /* a vertical stack/grid where every slide renders at its own position: scrolling the page reveals all */
    var seen = {}, ok = 0;
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (!shown(s)) return false;
      var r = rect(s);
      if (r.left < -10 || r.right > window.innerWidth + 10) return false;
      var key = Math.round(r.left / 20) + ':' + Math.round((r.top + window.scrollY) / 20);
      if (seen[key]) return false;
      seen[key] = 1; ok++;
    }
    return ok === slides.length;
  }

  function findThumbs(scope, track, count) {
    var lists = scope.querySelectorAll('*');
    for (var i = 0; i < lists.length; i++) {
      var el = lists[i];
      if (el === track || track.contains(el) || el.contains(track)) continue;
      if (el.children.length < 2) continue;
      var items = [];
      for (var j = 0; j < el.children.length; j++) {
        var c = el.children[j];
        if (isDup(c)) continue;
        var img = imgOf(c);
        if (!img) continue;
        var w = rect(img).width;
        if (w > 170) { items = null; break; }
        if (w === 0 && getComputedStyle(c).display === 'none') continue;
        items.push(c);
      }
      if (items && items.length >= 2 && items.length >= Math.min(count, 3)) return items;
    }
    return null;
  }

  function findArrows(scope) {
    var btns = scope.querySelectorAll('button, [role=button], a, .swiper-button-next, .swiper-button-prev, [class*=arrow], [class*=Arrow]');
    var prev = [], next = [];
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.closest('#relvie-offer-slot, .moonbundle-box')) continue;
      var t = ((b.className && b.className.baseVal !== undefined ? b.className.baseVal : b.className) || '') + ' ' + (b.getAttribute('aria-label') || '') + ' ' + (b.getAttribute('name') || '') + ' ' + (b.getAttribute('data-direction') || '');
      if (/next|right|forward/i.test(t)) next.push(b);
      else if (/prev|left|back/i.test(t)) prev.push(b);
    }
    return { prev: prev, next: next };
  }

  function addStyle() {
    if (document.getElementById('relvie-gallery-css')) return;
    var st = document.createElement('style');
    st.id = 'relvie-gallery-css';
    st.textContent =
      '.rvg-track{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory;scroll-behavior:smooth;transform:none!important;transition:none!important;gap:0!important;-webkit-overflow-scrolling:touch;scrollbar-width:none;position:relative!important;width:100%!important;max-width:100%!important;height:auto!important;margin-left:0!important;margin-right:0!important;padding:0!important;aspect-ratio:auto!important;min-height:0!important;grid-template-columns:none!important}' +
      '.rvg-track::-webkit-scrollbar{display:none}' +
      '.rvg-track>.rvg-slide{flex:0 0 100%!important;width:100%!important;max-width:100%!important;min-width:0!important;display:block!important;visibility:visible!important;opacity:1!important;position:relative!important;left:auto!important;top:auto!important;transform:none!important;margin:0!important;scroll-snap-align:center;scroll-snap-stop:always;grid-area:auto!important}' +
      '.rvg-track>.rvg-hide{display:none!important}' +
      '.rvg-track{align-items:flex-start!important}' +
      '.rvg-track>img.rvg-slide{position:relative!important;inset:auto!important;height:auto!important;max-height:min(125vw,720px);object-fit:contain}' +
      '.rvg-track>.rvg-slide img{opacity:1!important;visibility:visible!important}' +
      '.rvg-wrap{position:relative!important;overflow:visible!important}' +
      '.rvg-btn{position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.92);box-shadow:0 1px 6px rgba(0,0,0,.18);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;color:#111}' +
      '.rvg-btn svg{width:16px;height:16px}' +
      '.rvg-prev{left:8px}.rvg-next{right:8px}' +
      '.rvg-dots{display:flex;justify-content:center;gap:6px;margin:10px 0 4px}' +
      '.rvg-dots button{width:7px;height:7px;border-radius:50%;border:0;padding:0;background:rgba(0,0,0,.22);cursor:pointer}' +
      '.rvg-dots button.on{background:rgba(0,0,0,.75)}' +
      '.rvg-thumb-on{outline:2px solid currentColor;outline-offset:-2px;opacity:1!important}';
    document.head.appendChild(st);
  }

  function svg(dir) {
    return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="' + (dir < 0 ? 'M10 3 5 8l5 5' : 'M6 3l5 5-5 5') + '"/></svg>';
  }

  function enhance(track) {
    if (track.dataset.rvg) return;
    var slides = slidesOf(track);
    if (slides.length < 2) return;
    if (stackedAllVisible(track, slides)) { window.__rvgSkip = 'all-visible'; return; }
    if (!needsCarousel(track, slides)) { window.__rvgSkip = 'no-need'; return; }
    track.dataset.rvg = '1';
    addStyle();

    for (var i = 0; i < track.children.length; i++) {
      var c = track.children[i];
      if (slides.indexOf(c) >= 0) c.classList.add('rvg-slide'); else c.classList.add('rvg-hide');
      c.removeAttribute('aria-hidden');
      c.style.width = ''; c.style.transform = ''; c.style.left = ''; c.style.opacity = ''; c.style.display = '';
    }
    track.classList.add('rvg-track');
    track.style.transform = '';
    ['padding-top', 'padding-bottom', 'aspect-ratio', 'min-height'].forEach(function (pp) { track.style.setProperty(pp, pp === 'aspect-ratio' ? 'auto' : '0', 'important'); });
    /* parents of JS carousels often have fixed heights / clipping tied to the dead script */
    var p = track.parentElement;
    for (var k = 0; k < 3 && p; k++) {
      if (getComputedStyle(p).height !== 'auto' && /swiper|glide|splide|slick|flickity|carousel|slider/i.test(p.className || '')) p.style.height = 'auto';
      p = p.parentElement;
    }
    slides.forEach(function (s) {
      (s.tagName === 'IMG' ? [s] : [].slice.call(s.querySelectorAll('img'))).forEach(function (img) {
        if (!img.getAttribute('src') && img.dataset.src) img.src = img.dataset.src;
        img.loading = 'eager';
      });
    });

    /* slides whose image is absolutely positioned inside a box that only the dead script sized
       collapse to zero height: put the image back in normal flow */
    slides.forEach(function (s) {
      if (s.tagName === 'IMG' || rect(s).height > 40) return;
      var img = s.querySelector('img'); if (!img) return;
      var el = img;
      while (el && el !== s) {
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('padding-bottom', '0', 'important');
        el = el.parentElement;
      }
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('inset', 'auto', 'important');
      img.style.setProperty('object-fit', 'contain', 'important');
      s.style.setProperty('height', 'auto', 'important');
    });

    var scope = track.parentElement;
    for (var up = 0; up < 6 && scope.parentElement && !scope.parentElement.matches('body, main, .relvie-src'); up++) {
      if (rect(scope.parentElement).width > rect(track).width * 2.6) break;
      scope = scope.parentElement;
    }

    function idx() { var x = track.scrollLeft, b = 0, bd = 1e9; for (var i = 0; i < slides.length; i++) { var d = Math.abs(slides[i].offsetLeft - slides[0].offsetLeft - x); if (d < bd) { bd = d; b = i; } } return b; }
    function go(n) {
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    var thumbs = findThumbs(scope, track, slides.length);
    if (thumbs) {
      thumbs.forEach(function (t, n) {
        t.style.cursor = 'pointer';
        t.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(n % slides.length); }, true);
      });
    }

    var arrows = findArrows(scope);
    arrows.next.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx() + 1); }, true); b.removeAttribute('disabled'); b.classList.remove('swiper-button-disabled'); });
    arrows.prev.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx() - 1); }, true); b.removeAttribute('disabled'); b.classList.remove('swiper-button-disabled'); });

    var wrap = track.parentElement;
    wrap.classList.add('rvg-wrap');
    if (!arrows.next.filter(function (b) { return rect(b).width > 0; }).length) {
      var pv = document.createElement('button'); pv.type = 'button'; pv.className = 'rvg-btn rvg-prev'; pv.setAttribute('aria-label', 'Previous image'); pv.innerHTML = svg(-1);
      var nx = document.createElement('button'); nx.type = 'button'; nx.className = 'rvg-btn rvg-next'; nx.setAttribute('aria-label', 'Next image'); nx.innerHTML = svg(1);
      pv.addEventListener('click', function (e) { e.preventDefault(); go(idx() - 1); });
      nx.addEventListener('click', function (e) { e.preventDefault(); go(idx() + 1); });
      wrap.appendChild(pv); wrap.appendChild(nx);
      pv.style.top = nx.style.top = (track.offsetTop + track.offsetHeight / 2) + 'px';
    }
    var dots = null;
    if (!thumbs) {
      dots = document.createElement('div'); dots.className = 'rvg-dots';
      slides.forEach(function (_, n) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (n + 1)); d.addEventListener('click', function () { go(n); }); dots.appendChild(d); });
      track.insertAdjacentElement('afterend', dots);
    }
    function mark() {
      var n = idx();
      if (thumbs) thumbs.forEach(function (t, m) { t.classList.toggle('rvg-thumb-on', m === n); });
      if (dots) [].forEach.call(dots.children, function (d, m) { d.classList.toggle('on', m === n); });
      var btns = wrap.querySelectorAll('.rvg-btn');
      for (var b = 0; b < btns.length; b++) btns[b].style.top = (track.offsetTop + track.offsetHeight / 2) + 'px';
    }
    track.addEventListener('scroll', function () { clearTimeout(track._rvgT); track._rvgT = setTimeout(mark, 80); });
    track.scrollLeft = 0;
    mark();
  }

  function run() {
    var root = document.querySelector('.relvie-src') || document.querySelector('main') || document.body;
    var track = findTrack(root);
    window.__rvgTrack = track;
    if (track) enhance(track);
  }

  if (document.readyState === 'complete') setTimeout(run, 300);
  else window.addEventListener('load', function () { setTimeout(run, 300); });
})();
